<template>
  <div
    class="SalesReportReadItem"
    @click="edit">
    <div class="personalia">
      <div
        v-if="item.location"
        class="location">
        {{ item.location.name }}
      </div>
      <div
        v-if="!item.membership"
        class="noname">
        No name
      </div>
      <div
        v-if="item.membership"
        class="name">
        {{ item.membership.customer.firstName }}
        {{ item.membership.customer.lastName }}
      </div>
      <div
        v-if="item.membership"
        class="customer-type">
        {{ customerType }}
      </div>
    </div>
    <div class="amount">
      {{ item.amount }} NOK
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    customerType() {
      return {
        PORTFOLIO: "Porteføljekunde",
        NEWSALE: "Nysalgskunde",
        RESALE: "Resalgskunde",
        CAMPAIGN: "Kampanjekunde",
      }[this.item.customerType];
    },
  },

  methods: {
    edit() {
      if (!this.readOnly) {
        this.$router.push({
          name: "sales-report-item",
          params: { id: this.item.id },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.SalesReportReadItem {
  cursor: pointer;
  display: flex;
  border-bottom: solid 1px var(--heather);
  padding-bottom: 1em;
  padding-top: 1em;
  align-items: center;

  .personalia {
    flex: 1;
  }

  .name {
    font-weight: bold;
  }

  .noname {
    opacity: 0.5;
    font-style: italic;
  }

  .amount {
    font-weight: bold;
  }
}
</style>
